
import Navbar from "../components/framepart/Navbar/Navbar";
import MainPanel from "../components/framepart/MainPanel/MainPanel";
import Footer from "../components/framepart/Footer/Footer";
import "../styles/main.css";

// ================================
// Constantes structurelles du layout
// ================================
const NAVBAR_HEIGHT = 45; // Hauteur fixe de la Navbar
const FOOTER_HEIGHT = 40; // Hauteur fixe du Footer

const LayoutBasic = ({ children }) => {
  // ================================
  // Items du menu latéral (Sidebar)
  // ================================
  

  return (
    <div className="page-container" style={{ display: "flex", flexDirection: "column", height: "100vh", boxSizing: "border-box", overflow: "hidden", flexShrink: 0, }}>
      
      <div style={{ height: NAVBAR_HEIGHT, flexShrink: 0 }}>
        <Navbar logo={{ src: "/assets/logos/corelia.png", label: "Quantum Corelia" }} toolbar={<div style={{ display: "flex", gap: 6 }}>Outils</div>} />
      </div>

     
      <div className="Middle-container" style={{ display: "flex", height: `calc(100vh - ${NAVBAR_HEIGHT + FOOTER_HEIGHT}px)`, boxSizing: "border-box", minHeight: 0, overflowY: "none", flexShrink: 0, }}>
          
            
        
           <div className="Center-container" style={{ height: "100%", flex: 1, minHeight: 0, overflowY: "auto", boxSizing: "border-box", flexShrink: 0, }}>
            <MainPanel style={{ height: "100%", flex: 1, minHeight: 0, overflowY: "auto", boxSizing: "border-box", flexShrink: 0, }}>
              {children}
            </MainPanel>
           </div>
      </div>

        <div style={{ height: FOOTER_HEIGHT, padding: 0, pargin: 0,}}>   
          <Footer />
        </div>
    </div>
  );
};

export default LayoutBasic;
